module.exports = __webpack_public_path__ + "img/cl-logo-blog.020fabc6.png";